import { render, staticRenderFns } from "./kyb-use-dialog.vue?vue&type=template&id=a5bb6f38&scoped=true"
import script from "./kyb-use-dialog.vue?vue&type=script&lang=js"
export * from "./kyb-use-dialog.vue?vue&type=script&lang=js"
import style0 from "./kyb-use-dialog.vue?vue&type=style&index=0&id=a5bb6f38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bb6f38",
  null
  
)

export default component.exports